var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"statistics-section"},[_c('div',{staticClass:"container general-section"},[_c('h1',[_c('font-awesome-icon',{attrs:{"icon":"chart-line"}}),_vm._v("\n      Statistik\n    ")],1)]),_vm._v(" "),_c('market-statistics')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-43d3f4ed","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/Dashboard/Statistics/Index.vue
// module id = 718
// module chunks = 0